import React from 'react';
import { I18n } from '../../core/i18n/I18n';
export var PaginationControl = function PaginationControl(_ref) {
  var nextPage = _ref.nextPage,
      prevPage = _ref.prevPage,
      loading = _ref.loading;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
    onClick: prevPage,
    disabled: loading || !prevPage
  }, /*#__PURE__*/React.createElement(I18n, null, "Previous")), /*#__PURE__*/React.createElement("button", {
    onClick: nextPage,
    disabled: loading || !nextPage
  }, /*#__PURE__*/React.createElement(I18n, null, "Next")));
};
export default PaginationControl;